export default __webpack_public_path__ + "static/media/step-3-en.5cae47e4.svg";